<div class="panel-body" style="height: 100%;">
    <div x-ng-if="config.series.length>0 &amp;&amp; config.timeFrom &amp;&amp; config.timeTo" x-line-chart="" x-data="data" x-options="config">
    </div>
</div>


